import FJLocalStore from '../../../../store/FJLocalStore';
import WrongIcon from '../../../../assets/svg/textToVideo/oops.svg?react';
import EmptyIcon from '../../../../assets/svg/textToVideo/empty.svg?react';
import classNames from 'classnames';
import styles from './FJNoResults.module.less';
import PropTypes from 'prop-types';
// 搜索为空是 WrongIcon， 列表本身为空是 EmptyIcon

const FJNoResults = props => {
    const { className, style, isSearchEmpty = true, text, keywords } = props;

    // const textContent = () => {
    //     if (text) {
    //         return text;
    //     } else {
    //         if (keywords) {
    //             return FJLocalStore._('no-results') + ' "' + keywords + '"';
    //         } else {
    //             return FJLocalStore._('fetch-results-error');
    //         }
    //     }
    // };
    const textContent = !!text
        ? text
        : !!keywords
          ? FJLocalStore._('no-results') + ' "' + keywords + '"'
          : FJLocalStore._('fetch-results-error');
    return (
        <div className={classNames(styles.box, className)} style={style}>
            {isSearchEmpty ? <WrongIcon /> : <EmptyIcon />}
            <span className={styles.text}>{textContent}</span>
        </div>
    );
};

FJNoResults.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    isSearchEmpty: PropTypes.bool,
    text: PropTypes.string,
    keywords: PropTypes.string,
};
export default FJNoResults;
